<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='文章列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-select v-model="param.source_id" placeholder="请选择来源" @change="sourceChange" filterable>
            <el-option label="请选择来源" :value="0"></el-option>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="param.category_id" placeholder="请选择专辑" @change="categoryChange" filterable>
            <el-option label="请选择专辑" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="onTimeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="发布开始时间"
            end-placeholder="发布结束时间"
            @change="onTimeRangeChange">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入文章标题" v-model="param.keyword" clearable @clear="getArticleList">
            <el-button slot="append" icon="el-icon-search" @click="getArticleList"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="articleList" @sort-change="handleSortChange" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" sortable="custom" align="center" width="70px"></el-table-column>
      <el-table-column prop="title" label="名称" align="center"></el-table-column>
      <el-table-column prop="source_title" label="来源" align="center"></el-table-column>
      <el-table-column prop="category_title" label="专辑" align="center"></el-table-column>
      <el-table-column prop="author_title" label="作者" align="center"></el-table-column>
      <el-table-column prop="hits" label="点击量" align="center"></el-table-column>
      <el-table-column prop="sort_num" label="排序值" align="center"></el-table-column>
      <el-table-column prop="on_time" label="发布时间" sortable="custom" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.on_time>0">{{scope.row.on_time | dateTimeFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">上架</span><span v-else>下架</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          <el-button type="success" icon="el-icon-edit" size="mini" @click="openPicListDialog(scope.row.id)">图片</el-button>
          <el-link :href="scope.row.source_url" target="_blank">源链接</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <handpick-article-add
      :visible="addDialogAvaible"
      :id="currentId"
      @add="addArticle"
      @update="updateArticle"
      @closeDialog="closeAddDialog">
    </handpick-article-add>
    <handpick-article-pic-list
      :visible="picListAvaible"
      :id="currentId"
      @closeDialog="closePicListDialog">
    </handpick-article-pic-list>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import handpickArticleAdd from './handpickArticleAdd.vue'
import handpickArticlePicList from './handpickArticlePicList.vue'
export default {
  name: 'handpick_article_list',
  components: {
    'bread-crumb': BreadCrumb,
    'handpick-article-add': handpickArticleAdd,
    'handpick-article-pic-list': handpickArticlePicList
  },
  data () {
    return {
      sourceList: [],
      categoryList: [],
      articleList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        source_id: 0,
        category_id: 0,
        min_on_time: 0,
        max_on_time: 0,
        keyword: '',
        order_by: '',
        order: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false,
      picListAvaible: false,
      onTimeRange: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created () {
    this.getArticleList()
    this.getSourceList()
  },
  methods: {
    async getArticleList () {
      const res = await this.$http.get('/admin/handpick_article/list', this.param)
      if (res.code === 0) {
        this.articleList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSourceList () {
      const res = await this.$http.get('/admin/handpick_source/select_list')
      if (res.code === 0) {
        this.sourceList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    sourceChange () {
      this.param.category_id = 0
      this.param.keyword = ''
      this.param.page = 1
      this.getCategoryList()
      this.getArticleList()
    },
    categoryChange () {
      this.param.keyword = ''
      this.param.page = 1
      this.getArticleList()
    },
    onTimeRangeChange () {
      if (this.onTimeRange != null) {
        this.param.min_on_time = this.onTimeRange[0].getTime() / 1000
        this.param.max_on_time = this.onTimeRange[1].getTime() / 1000
      } else {
        this.param.min_on_time = 0
        this.param.max_on_time = 0
      }
      this.getArticleList()
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/handpick_category/select_list', {
        source_id: this.param.source_id
      })
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSortChange ({ prop, order }) {
      this.param.order_by = prop
      if (order === 'ascending') {
        this.param.order = 'ASC'
      } else {
        this.param.order = 'DESC'
      }
      this.param.page = 1
      this.param.keyword = ''
      this.getArticleList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getArticleList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getArticleList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    closePicListDialog () {
      this.picListAvaible = false
      this.currentId = 0
    },
    openPicListDialog (id) {
      this.currentId = id
      this.picListAvaible = true
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/handpick_article/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getArticleList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addArticle (data) {
      const res = await this.$http.post('/admin/handpick_article/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getArticleList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateArticle (id, data) {
      const res = await this.$http.post('/admin/handpick_article/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getArticleList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
